/* jshint esversion: 6 */
import { filter, mergeMap } from 'rxjs/operators';
import api from 'app/redux/api.js';
import {
    EverqueueActions
} from 'app/redux/actions.js';
import * as constants from 'app/redux/constants.js';

export const fetchEverqueueEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.EVERQUEUE_LIST && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, EverqueueActions.receiveEverqueue))
);

export const deleteEverqueueItemEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.EVERQUEUE_DELETE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, null, action.post, EverqueueActions.deletedEverqueue))
);

export const updateEverqueueItemEpic = (action$, state$) => action$.pipe(
    filter(action => (action.type === constants.EVERQUEUE_UPDATE && action.status === constants.STATE_TXRX)),
    mergeMap(action => api(action.type, state$, action.post.id, action.post.item, EverqueueActions.updatedEverqueue))
);
